<template>
	<div class="small-12 flex vertical-align numberChart">
		<div class="small-12 large-2 trendIcon flex justify-center">
			<i class="material-icons-outlined cLightGreen borderRadius4 flex justify-center vertical-align north" v-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage >= 0">north</i>
			<i class="material-icons-outlined cGreen borderRadius4 flex justify-center vertical-align north" v-else-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage < 0">south</i>
			<i class="material-icons-outlined cGreen borderRadius4 flex justify-center vertical-align north" v-else-if="trend_percentage >= 0">north</i>
			<i class="material-icons-outlined cRed borderRadius4 flex justify-center vertical-align south" v-else>south</i>
		</div>
		<div class="small-12 large-10 columns">
			<h2 class="small-12 flex vertical-align" v-if="is_revenue && chartValue > 100000000">
				${{chartValue | toMillionsRevenue}} M
				<span class="cLightGreen" v-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage < 0">{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cRed" v-else>{{trend_percentage}}%</span>
			</h2>
			<h2 class="small-12 flex vertical-align" v-else-if="is_revenue && chartValue > 100000">
				${{chartValue | toThousandsRevenue}} K
				<span class="cLightGreen" v-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage < 0">{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cRed" v-else>{{trend_percentage}}%</span>
			</h2>
			<h2 class="small-12 flex vertical-align" v-else-if="is_revenue">
				${{chartValue | twoDecimals}} 
				<span class="cLightGreen" v-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage < 0">{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="trend_percentage >= 0">{{trend_percentage}}%</span>
				<span class="cRed" v-else>{{trend_percentage}}%</span>
			</h2>
			<h2 class="small-12 flex vertical-align" v-else-if="!is_revenue && chartValue > 1000000">
				{{chartValue | twoDecimals}} 
				<span class="cLightGreen" v-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="chartLabel == 'Expenses' && trend_percentage < 0">{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cRed" v-else>{{trend_percentage}}%</span>
			</h2>
			<h2 class="small-12 flex vertical-align" v-else-if="is_revenue && chartValue > 1000">
				{{chartValue | twoDecimals}} 
				<span class="cLightGreen" v-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage < 0">{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cRed" v-else>{{trend_percentage}}%</span>
			</h2>
			<h2 class="small-12 flex vertical-align" v-else>
				{{chartValue | twoDecimals}} 
				<span class="cLightGreen" v-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="chartLabel == 'Expenses' || chartLabel == 'Operating Expenses' && trend_percentage < 0">{{trend_percentage}}%</span>
				<span class="cLightGreen" v-else-if="trend_percentage >= 0">+{{trend_percentage}}%</span>
				<span class="cRed" v-else>{{trend_percentage}}%</span>
			</h2>
			<p class="small-12">{{chartLabel}}</p>
		</div>
		<div class="small-12 columns chart-line-xxs" style="margin-top:10px;" v-if="chartData && chartOptions">
			<line-chart :chartOptions="chartOptions" :chartData="chartData"></line-chart>
		</div>
	</div>
</template>

<script>

	// Import the mixins
	import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'

	// Import the components
	import LineChart from '@/components/framework/charts/LineChart.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PercentageChartTrending',

		/*
		**  Register the components
		*/

		components: {

		    LineChart

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			AbbreviateNumbersFilters

		],

		/*
		** Set the props
		*/

		props: {

			chartValue: {
				type: Number,
				default: 0
			},
			is_revenue: {
				type: Boolean,
				default: false
			},
			chartLabel: {
				type: String, 
				default: null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			trend_percentage: 0,
			dateParam: 12,
			chartData: null,
			chartOptions: null,
			chartLabels: []
			
		}),

		/*
		**  Do this first
		*/

		mounted() {

			// Set the chart label dates
			this.setDates();

			// Populate the chart options
			this.populateChartOptions();

			// Set the empty chart - remove and add to watcher
			this.setEmptyChart();

		},

		/*
		**  Watch em'
		*/

		watch: {

			statValue: {

				immediate: true, // Load on created
				handler(statValue) {

					if (statValue) this.calculateTrend();

				}

			}

		},

		/*
		**  Set up the methods
		*/

		methods: {

			calculateTrend: function() {

				// Get the past data

				// Calculate and set the trend percentage

			},

			setDates: function() {

				if (this.chartLabels.length == 0) {

					// Set the var
					let tempLabels = [];

					// Add dates to the temp array
					for (let i = 0; i < this.dateParam; i++) {

						let optionDate = moment().subtract(i, 'months').format('MMM');

						tempLabels.push(optionDate);

					}

					// Reverse the array and add to global object
					this.chartLabels = tempLabels.reverse();

				}

			},

			populateChartOptions: function() {

				// Populate the options
				this.chartOptions = {
					responsive: true, 
					maintainAspectRatio: false,
					scales: {
						 yAxes: [{
						 	display: false,
						 	beginAtZero: true,
						 	gridLines: {
			                    drawTicks: true,
			                    display: true,
			                    color: '#f4f6f8'
			                }
			            }],
			            xAxes: [{
			            	display: false,
			            	gridLines: {
			                    drawTicks: true,
			                    display: false,
			                    color: '#f4f6f8',
			                    zeroLineColor: '#f4f6f8'
			                }
			            }]
					},
					elements: {
	                    point:{
	                        radius: 1
	                    },
	                    line: {
				            tension: 0
				        }
	                },
	                legend: {
			            display: false
			        },
			        tooltips: {
				         enabled: true
				    },
				    layout: {
					padding: {
							top: 10
						}
					}
				}

			},

			setEmptyChart: function() {

				// Set the data based off of date param
				let tempData = [];

				for (let i = 0; i < this.dateParam; i++) {

					tempData.push(0);

				}

				// Populate the chart data
				this.chartData = {

					labels: this.chartLabels,
					datasets: [
						{
							label: 'Gross Income',
							backgroundColor: 'rgba(24,187,247,.1)',
							borderColor: '#18bbf7',
							borderWidth: 2,
							data: tempData
						}
					]

				}

			}

		}

	}

</script>